import * as React from "react";
import type { SVGProps } from "react";
const SvgUnblockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="unblock_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M42.667 512a42.667 42.667 0 0 0 42.666 42.667h451.84l-98.133 97.706a42.752 42.752 0 0 0 13.867 69.931 42.667 42.667 0 0 0 46.72-9.344l170.666-170.667a42.667 42.667 0 0 0 8.96-14.08 42.667 42.667 0 0 0 0-32.426 42.667 42.667 0 0 0-8.96-14.08L499.627 311.04a42.795 42.795 0 1 0-60.587 60.587l98.133 97.706H85.333A42.667 42.667 0 0 0 42.667 512zm768-426.667H341.333a128 128 0 0 0-128 128v85.334a42.667 42.667 0 0 0 85.334 0v-85.334a42.667 42.667 0 0 1 42.666-42.666h469.334a42.667 42.667 0 0 1 42.666 42.666v597.334a42.667 42.667 0 0 1-42.666 42.666H341.333a42.667 42.667 0 0 1-42.666-42.666v-85.334a42.667 42.667 0 1 0-85.334 0v85.334a128 128 0 0 0 128 128h469.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128z"
    />
  </svg>
);
export default SvgUnblockIcon;
